import styled from 'styled-components'
import { Color } from 'root-constants'

export const StyledSelectGoal = {
  Wrapper: styled.div`
    position: relative;
    z-index: 2;
  `,
  Title: styled.h1`
    margin-bottom: 32px;
    font-weight: 700;
    font-size: 28px;
    line-height: 38px;
    text-align: center;
    color: ${Color.WHITE};
  `,
  Subtitle: styled.p`
    margin: 64px 0 32px;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #f1dfff;
  `,
  SelectGoal: styled.p`
    margin-bottom: 24px;
    font-weight: 700;
    font-size: 18px;
    line-height: 25px;
    text-align: center;
    color: ${Color.WHITE};
  `,
}
